import React from 'react';
import Icon from '@mdi/react';
import PropTypes from 'prop-types';
import { v1 as uuidV1 } from 'uuid';
import { mdiFileDocumentMultiple } from '@mdi/js';
import { ellipsisBetweenText, getDownloadService } from '../utils/smartutils';

const FileWrapper = ({ files, openBlank }) => {
  const getFileName = (file) => {
    return file.fileName || file.name;
  };

  const handler = (file) => {
    if (openBlank) {
      window.open(file.preview, '_blank');
    } else {
      getDownloadService(file.preview, getFileName(file));
    }
  };

  const buildFiles = () => {
    return files.map((file) => {
      return (
        <div className="file-tile" key={uuidV1()}>
          <div className="file-tile-content">
            <Icon path={mdiFileDocumentMultiple} size={0.8} color="#4394FA" />
            <button type="button" onClick={() => handler(file)}>
              {ellipsisBetweenText(getFileName(file))}
            </button>
          </div>
        </div>
      );
    });
  };

  return <div className="file-wrapper">{buildFiles()}</div>;
};

FileWrapper.propTypes = {
  files: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape)).isRequired,
  openBlank: PropTypes.bool,
};

FileWrapper.defaultProps = {
  openBlank: false,
};

export default FileWrapper;
